export default __webpack_public_path__ + "static/media/Yakult.13e23aa8.png";